import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { MdfRequestRow } from "./types";

// Reads every MDF request for the partner (all statuses). The list page
// filters client-side by tab (drafts / pending / approved / closed) — keeps
// the network call cacheable across tab switches and matches sub-bucket 2's
// pattern.
export function useMdfRequestsList() {
  return useQuery<MdfRequestRow[]>({
    queryKey: queryKeys.mdf.requests(),
    queryFn: () => apiFetch<MdfRequestRow[]>("/portal/mdf/requests"),
  });
}
